module.exports = __webpack_public_path__ + "img/eurogastro.0630cc2f.png";